import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { IMAGES, BRAND } from "../data/content";

export default function ChiSiamoPage() {
  return (
    <div data-testid="about-page" className="pt-[140px] pb-20">
      <div className="max-w-[1480px] mx-auto px-5 sm:px-8 lg:px-12">
        <div className="overline mb-6">Chi siamo</div>
        <h1 className="font-display text-[clamp(2.8rem,7vw,6rem)] leading-[0.9] tracking-tighter font-medium max-w-5xl">
          Ingegneri della luce,<br />professionisti del <em className="italic font-light text-[#EB0D0D]">comfort</em>.
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-20">
          <div className="lg:col-span-7">
            <img src={IMAGES.hero_interior} alt="Showroom" className="w-full h-[520px] object-cover rounded-sm" />
          </div>
          <div className="lg:col-span-5 flex flex-col justify-center">
            <p className="text-lg text-[#5C5A55] leading-relaxed mb-6">
              Koreko Direct nasce a <b>Gaeta</b> come punto di riferimento nel Lazio per infissi e serramenti di altissima qualità, 
              con il proprio stabilimento produttivo a Sabaudia, in Via Zannone 47, cuore della nostra attività e della nostra esperienza nel settore. 
              
            </p>
            <p className="text-lg text-[#5C5A55] leading-relaxed mb-6">
              
              Negli anni abbiamo aperto la <strong>divisione Outdoor</strong> per rispondere alla richiesta di spazi esterni vivibili: vetrate panoramiche, pergole bioclimatiche e impianti fotovoltaici.
            </p>
            <p className="text-lg text-[#5C5A55] leading-relaxed">
              La nostra filosofia è semplice: <em>eleganza, semplicità, innovazione</em>. 
              Ogni progetto è un'opportunità per migliorare il modo in cui i nostri clienti vivono i loro spazi.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-28">
          {[
            { n: "Qualità", d: "Solo brand certificati europei: Korus, Gibus, e altri leader di settore. Garanzia decennale su strutture e installazione." },
            { n: "Consulenza", d: "Tecnico dedicato dal primo sopralluogo alla posa finale. Trasparenza totale su materiali, tempi e costi." },
            { n: "Servizio", d: "Pratiche fiscali, finanziamenti agevolati, assistenza pre e post vendita. Pensiamo a tutto noi." },
          ].map((v) => (
            <div key={v.n} className="border-t-2 border-[#1A1918] pt-6">
              <div className="font-display text-3xl tracking-tight mb-4">{v.n}</div>
              <p className="text-[#5C5A55] leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-28 bg-[#F0EFEB] p-10 md:p-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="overline mb-4">I nostri showroom</div>
            <h2 className="font-display text-3xl md:text-4xl tracking-tight mb-4">Visita lo showroom più vicino a te</h2>
            <p className="text-[#5C5A55] leading-relaxed mb-6">
              I nostri architetti e ingegneri sono al tuo fianco per accompagnarti in ogni progetto, dalla scelta degli infissi agli interventi di ristrutturazione e interior design. 
              Anche un semplice consiglio può fare la differenza: la tua casa merita professionisti qualificati e prodotti d'eccellenza.
            </p>
            <Link to="/contatti" data-testid="about-cta-contatti" className="btn-primary">Prenota visita <ArrowUpRight size={16} weight="bold" /></Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="bg-[#FAF9F6] border-t-2 border-[#EB0D0D] p-6">
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#EB0D0D] mb-3">Gaeta</div>
              <div className="font-display text-lg leading-snug">Via Lungomare<br />G. Caboto, 74</div>
              <div className="text-xs text-[#5C5A55] mt-3">Showroom principale</div>
            </div>
            <div className="bg-[#FAF9F6] border-t-2 border-[#1A1918] p-6">
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#EB0D0D] mb-3">Sabaudia</div>
              <div className="font-display text-lg leading-snug">Via Zannone, 47<br />04016 Sabaudia</div>
              <div className="text-xs text-[#5C5A55] mt-3 italic">Solo su appuntamento</div>
            </div>
            <div className="bg-[#FAF9F6] border-t-2 border-[#1A1918] p-6">
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#EB0D0D] mb-3">Roma</div>
              <div className="font-display text-lg leading-snug">Via Enrico Raimondo, 46<br />00173 Roma</div>
              <div className="text-xs text-[#5C5A55] mt-3 italic">Solo su appuntamento</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
